var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c("h4", { staticClass: "card-title" }, [
              _vm._v("Resultado da pesquisa")
            ]),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { cursor: "pointer" },
                    attrs: { data: _vm.dados }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        fixed: "fixed",
                        label: "Nº do processo",
                        "min-width": "150",
                        prop: "numeroProcesso"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        fixed: "fixed",
                        label: "Ordem de serviço",
                        "min-width": "250",
                        prop: "ordensServico"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Município",
                        "min-width": "150",
                        prop: "municipioFormatado"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Geomensor / Fiscalizador",
                        "min-width": "200",
                        prop: "geomensor"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Situação do Geomensor / Fiscalizador",
                        "min-width": "250",
                        prop: "situacaoGeomensor"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Vistoriador",
                        "min-width": "180",
                        prop: "vistoriador"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Situação do vistoriador",
                        "min-width": "200",
                        prop: "situacaoVistoriador"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "Data do processo",
                        "min-width": "140",
                        prop: "dataFormatada"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc82ac92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc82ac92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/components/os/TabelaProcesso.vue
// module id = null
// module chunks = 